module.exports = __webpack_public_path__ + "media/application/images/ui/dont-buy-3b40eb15a51525ea2daaf1e333bb09ae.png";